const MatchType = {
    SINGLE_EXACT: "SINGLE_EXACT",
    GROUP_EXACT: "GROUP_EXACT",
    GROUP_PARTIAL: "GROUP_PARTIAL",
}

export default MatchType;